import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthStorageService } from '../services/auth-storage.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return false;
  }

  const authService = inject(AuthService);
  const authStorage = inject(AuthStorageService);
  const router = inject(Router);

  await authService.bootstrap();

  if (authStorage.isAuthenticated() && authStorage.currentUser()) {
    return true;
  }

  // Allow unauthenticated payment return tab on /client/membership to execute BroadcastChannel notification & display tab return view
  const queryParams = route.queryParams;
  const isMembershipRoute = state.url.includes('/client/membership');
  const hasPaymentParam = !!(
    queryParams['paymentId'] ||
    queryParams['payment_id'] ||
    queryParams['id'] ||
    queryParams['status'] ||
    queryParams['paymentStatus'] ||
    queryParams['payment_status'] ||
    queryParams['success']
  );
  const isReferrerMatch2Pay = typeof document !== 'undefined' &&
    document.referrer &&
    (document.referrer.toLowerCase().includes('match2pay') || document.referrer.toLowerCase().includes('checkout'));

  if (isMembershipRoute && (hasPaymentParam || isReferrerMatch2Pay)) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};
